import { registerBlockType } from '@wordpress/blocks';
import './style.scss';

import attributes from './attributes';
import metadata from './block.json';

/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';

/**
 * Block Registration
 */
registerBlockType(metadata, {
    icon: {
        src: (
            <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            style={{
                fill: 'none'
            }}
            color="#2e62ff"
        >
            <path d="M22 3H2V21H22V3Z" stroke="#2e62ff" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M2 9.5L22 9.5" stroke="#2e62ff" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M5 6H7M9 6H11" stroke="#2e62ff" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
        )
    },
    attributes,
    edit: Edit,
    save: Save
});
